import { el } from "./dom";

// Render emphasis (**...**) as a MEDIUM-weight span, never bold: the brand caps
// at weight 500. Everything goes through textContent; model text is never HTML.
function inline(text: string): Node[] {
  const nodes: Node[] = [];
  const re = /\*\*(.+?)\*\*/g;
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text))) {
    if (m.index > last) nodes.push(document.createTextNode(text.slice(last, m.index)));
    nodes.push(el("span", { class: "strong", text: m[1]! }));
    last = m.index + m[0].length;
  }
  if (last < text.length) nodes.push(document.createTextNode(text.slice(last)));
  return nodes;
}

const stripMd = (s: string) => s.replace(/\*\*/g, "").trim();

// Render model output as a structured block. Headed lines (markdown #, an
// all-caps label, or a whole line wrapped in **) become headings; rules become
// a thin divider; blank lines break paragraphs; inline ** becomes emphasis.
export function renderReport(text: string): HTMLElement {
  const wrap = el("div", { class: "report" });
  let para: string[] = [];
  const flush = () => {
    if (para.length) {
      wrap.append(el("p", { class: "report__p" }, ...inline(para.join(" "))));
      para = [];
    }
  };
  for (const rawLine of text.split("\n")) {
    const line = rawLine.trim();
    if (!line) {
      flush();
      continue;
    }
    if (/^[-—–*_]{3,}$/.test(line)) {
      flush();
      wrap.append(el("div", { class: "report__rule" }));
      continue;
    }
    const md = line.match(/^#{1,3}\s+(.*)$/);
    const caps = line.match(/^([A-Z][A-Z0-9 ,/&-]{3,}):?$/);
    const boldLine = line.match(/^\*\*(.+?)\*\*:?$/);
    if (md) {
      flush();
      wrap.append(el("h3", { class: "report__h", text: stripMd(md[1]!) }));
    } else if (caps) {
      flush();
      wrap.append(el("span", { class: "label report__label", text: caps[1]! }));
    } else if (boldLine) {
      flush();
      wrap.append(
        el("p", { class: "report__sub" }, el("span", { class: "strong", text: boldLine[1]! })),
      );
    } else if (/^[-—–*]\s+/.test(line)) {
      flush();
      wrap.append(
        el("p", { class: "report__li" }, ...inline(line.replace(/^[-—–*]\s+/, ""))),
      );
    } else {
      para.push(line);
    }
  }
  flush();
  return wrap;
}
